<template>
  <div>
    <v-row>
      <v-col cols="12">
        <label style="font-weight: bold">{{
          $t("Panier.SectionMesureAide.TitreSectionMesureAide")
        }}</label>
      </v-col>
    </v-row>

    <v-col
      cols="12"
      class=""
    >
      <v-row class="mt-0">
        <v-col
          cols="6"
          sm="4"
          class="py-0 pr-1 pl-0"
          v-for="mesure in inscriptionStore.listeMesureAide"
          v-bind:key="mesure.id"
        >
          <v-checkbox
            class="pr-1 mt-0 mb-1 py-0"
            hide-details="auto"
            v-on:change="modificationMesureAide(mesure.id, $event)"
            :label="mesure.identifiant"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-col>
    <v-row class="mt-0">
      <v-col
        cols="12"
        sm="8"
        class="py-1 pr-1"
      >
        <v-file-input
          outlined
          v-on:input="emettre"
          dense
          v-if="UtiliseMesureAide"
          :accept="ExtensionPermise"
          :rules="[
            ...rules.fichier,
            ...regles.extensionPermise,
            ...regles.tailleMax,
          ]"
          v-model="mesuresAide.planIntervention"
          :label="$t('Panier.SectionDocumentRequis.PlanIntervention')"
        ></v-file-input>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col
        cols="12"
        class="py-0 pr-1"
      >
        <v-textarea
          class=""
          rows="3"
          outlined
          v-model="mesuresAide.informationComplementaire"
          v-on:input="modificationMesureAide"
          :label="$t('Panier.SectionMesureAide.InformationsComplementaires')"
          :placeholder="
            $t(
              'Panier.SectionMesureAide.ExempleTextAreaInformationComplementaire'
            )
          "
          style="width: 100%"
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import useAppStore from '@/store/appStore';
import useInscriptionStore from '@/store/inscriptionStore';
import csqcoutils from '../../outils/CSQCOutils';

export default {
  name: 'MesureAide',
  props: {
    value: Object,
  },
  setup() {
    const appStore = useAppStore();
    const inscriptionStore = useInscriptionStore();

    return { appStore, inscriptionStore };
  },
  data() {
    return {
      listeMesureAideCoche: [],
      mesuresAide: Object,
      rules: {
        fichier: [
          (v) => !!v || this.$t('erreurs.FichierRequis'),
          (v) => (v && v.size > 0) || this.$t('erreurs.FichierRequis'),
        ],
      },
      regles: {
        extensionPermise: [
          (value) => this.validerExtension(value) ||
            this.$t('erreurs.extension_non_permise'),
        ],
        tailleMax: [
          (value) => this.validerTailleTropGrande(value) ||
            `La taille maximale est de ${csqcoutils.TailleMax() / 1048576
            } Mo`,
        ],
      },
    };
  },

  methods: {
    modificationMesureAide(mesureAide, e) {
      let listeMesureId = '';
      if (e) {
        this.listeMesureAideCoche.push(mesureAide);
        listeMesureId = this.listeMesureAideCoche.join(';');
        this.mesuresAide.mesureAidesId = listeMesureId;
        this.emettre();
      } else if (e === false) {
        const index = this.listeMesureAideCoche.indexOf(mesureAide);
        if (index > -1) {
          this.listeMesureAideCoche.splice(index, 1);
        }

        listeMesureId = this.listeMesureAideCoche.join(';');
        this.mesuresAide.mesureAidesId = listeMesureId;
        this.emettre();
      }
    },
    emettre() {
      this.$emit('input', this.mesuresAide);
    },
    validerExtension(fichier) {
      if (fichier != null) {
        const ext = csqcoutils.ExtraireExtension(fichier);
        if (this.appStore.modele.extensionsPermise.includes(ext.toLowerCase()) === false) {
          return false;
        }
        return true;
      } return false;
    },
    validerTailleTropGrande(fichier) {
      if (fichier != null) {
        if (fichier.size > csqcoutils.TailleMax()) return false;
        return true;
      } return false;
    },
  },
  computed: {
    UtiliseMesureAide() {
      if (this.listeMesureAideCoche.length > 0) return true;
      return false;
    },
    ExtensionPermise() {
      let resultat = '';
      this.appStore.modele.extensionsPermise.forEach((element) => {
        resultat += `.${element},`;
      });
      resultat = resultat.slice(0, -1);
      return resultat;
    },
  },
  async created() {
    this.mesuresAide = this.value;
  },
  watch: {
    value: {
      handler(newValue) {
        this.mesuresAide = newValue;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
